import getCurrentRoute from './getCurrentRoute';
import mailCategoryRouteHandler from './mailCategoryRouteHandler';
import mailFolderRouteHandler from './mailFolderRouteHandler';
import mailGroupFilesRouteHandler from './mailGroupFilesRouteHandler';
import { mailGroupFilesSPCleanupRouteHandler, mailGroupFilesSXSNavigationRouteHandler, mailGroupFilesSxSCleanupRouteHandler, } from './mailGroupFilesFilePreviewRouteHandlers';
import mailGroupRouteHandler from './mailGroupRouteHandler';
import mailModuleRouteHandler from './mailModuleRouteHandler';
import mailRowRouteHandler from './mailRowRouteHandler';
import { mailSxSCleanupRouteHandler, mailSxSNavigationRoutehandler } from './mailSxSRouteHandler';
import { mailInClientStoreRouteHandler } from './mailInClientStoreRouteHandler';
import personaRouteHandler from './personaRouteHandler';
import privateDistributionListRouteHandler from './privateDistributionListRouteHandler';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { initializeDomainConnectRoutes } from 'owa-domain-connect';
import { IsGroupsEnabled } from 'owa-group-feature-flags';
import { initializeOptionRoutes } from 'owa-options-router';
import { mailComposeCleanupRouteHandler, mailComposeNavigationRouteHandler, } from './mailComposeRouteHandler';
export var mailRouterOptions = {
    routeGenerator: getCurrentRoute,
    defaultRoute: '/',
};
export function initializeMailRoutes(registerRoute) {
    registerRoute('/compose', mailComposeNavigationRouteHandler, mailComposeCleanupRouteHandler);
    registerRoute('/compose/:draftId', mailComposeNavigationRouteHandler, mailComposeCleanupRouteHandler);
    registerRoute('/id/:rowId', mailRowRouteHandler);
    initializeGroupRoutes(registerRoute);
    initializeOptionRoutes();
    initializeDomainConnectRoutes();
    registerRoute('/persons/:favoriteNodeId', personaRouteHandler);
    if (isControlFeatureEnabled('peo-favoritePdls')) {
        registerRoute('/contactlists/:favoriteNodeId', privateDistributionListRouteHandler);
    }
    if (isControlFeatureEnabled('tri-categories-advanced')) {
        registerRoute('/category/:categoryId', mailCategoryRouteHandler);
    }
    registerRoute('/inclientstore', mailInClientStoreRouteHandler);
    registerRoute('/inclientstore/assetid/:assetId', mailInClientStoreRouteHandler);
    registerRoute('/inclientstore/assetid/:assetId/campaignid/:campaignId/providerid/:providerId', mailInClientStoreRouteHandler);
    registerRoute('/:folderId/id/:rowId/sxs/:itemId/:attachmentId', mailSxSNavigationRoutehandler, mailSxSCleanupRouteHandler);
    registerRoute('/:folderId/id/:rowId/sxs/:attachmentId', mailSxSNavigationRoutehandler, mailSxSCleanupRouteHandler);
    registerRoute('/:folderId/compose/:draftId', mailComposeNavigationRouteHandler, mailComposeCleanupRouteHandler);
    registerRoute('/:folderId/compose', mailComposeNavigationRouteHandler, mailComposeCleanupRouteHandler);
    registerRoute('/:folderId/id/:rowId', mailRowRouteHandler);
    // routes with "/:folderId" must be after routes with "/<string constant>"
    registerRoute('/:folderId', mailFolderRouteHandler);
    registerRoute('/', mailModuleRouteHandler);
}
function initializeGroupRoutes(registerRoute) {
    if (IsGroupsEnabled()) {
        registerRoute('/group/:groupDomain/:groupAlias', mailGroupRouteHandler);
        registerRoute('/group/:groupDomain/:groupAlias/email', mailGroupRouteHandler);
        registerRoute('/group/:groupDomain/:groupAlias/action/:actionId', mailGroupRouteHandler);
        initializeGroupFilesRoutes(registerRoute);
    }
}
function initializeGroupFilesRoutes(registerRoute) {
    registerRoute('/group/:groupDomain/:groupAlias/files', mailGroupFilesRouteHandler);
    registerRoute('/group/:groupDomain/:groupAlias/files/sxs/sp/:spFileId', mailGroupFilesSXSNavigationRouteHandler, mailGroupFilesSPCleanupRouteHandler);
    registerRoute('/group/:groupDomain/:groupAlias/files/sxs/attachment/:attachmentId', mailGroupFilesSXSNavigationRouteHandler, mailGroupFilesSxSCleanupRouteHandler);
    registerRoute('/group/:groupDomain/:groupAlias/files/((\\w|.)*)', mailGroupFilesRouteHandler);
}
//# sourceMappingURL=mailRoutes.js.map